
import { apiFetch } from "../_utils/apiInterceptor.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = `${backendUrl}/api/v1/tenants`;
  
export const getTenant = async (tenantId) => {
  return await apiFetch(
    `${BASE_URL}/get/${tenantId}`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json"
    },
  });
};  
